import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { company } from '../data/company';
interface ConsultationCtaProps {
  heading?: string;
  description?: string;
}
export function ConsultationCta({
  heading = 'Discuss your situation with a professional fiduciary',
  description = 'Tell us what needs to be handled. We will explain which services apply and what working together would look like — with no obligation.'
}: ConsultationCtaProps) {
  return <section className="bg-navy-900" data-id="element-23" data-mp="2x3521enwp6x3">
      <div className="mx-auto flex max-w-shell flex-col gap-10 px-6 py-20 lg:flex-row lg:items-center lg:justify-between" data-id="element-24" data-mp="2x23dq8hvqnxf">
        <div className="max-w-2xl" data-id="element-25" data-mp="3216ma2x2jca5">
          <h2 className="font-serif text-3xl leading-tight text-white sm:text-[40px]" data-id="element-26" data-mp="364w7qjig5dqy">
            {heading}
          </h2>
          <p className="mt-5 text-[17px] leading-relaxed text-navy-200" data-id="element-27" data-mp="17qb8mm71170i">{description}</p>
        </div>
        <div className="flex shrink-0 flex-wrap gap-4" data-id="element-28" data-mp="1br3ldpf3xu1j">
          <Link to="/contact" className="flex items-center gap-2 bg-gold px-7 py-4 text-[15px] font-medium text-navy-950 transition-colors duration-150 ease-out hover:bg-gold-light" data-id="element-29" data-mp="3v4kle9flodff">
            Request a Consultation
            <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-30" data-mp="3leivdc3oskxv" />
          </Link>
          <a href={company.phoneHref} className="border border-white/25 px-7 py-4 text-[15px] font-medium text-white transition-colors duration-150 ease-out hover:bg-white/10" data-id="element-31" data-mp="3ggpsarxok71t">
            {company.phoneDisplay}
          </a>
        </div>
      </div>
    </section>;
}